<template>
  <div class="groupsPrdtListing">
    <section class="detail_content">
      <ul class="list_panel" v-if="availableCutpriceList.length > 0">
        <router-link
          tag="li"
          v-for="(availCutPrice,index) in availableCutpriceList"
          :key="index"
          :to="`/detail/${ availCutPrice.saleReferenceID}`"
        >
          <span class="img_wrapper">
            <img :src="availCutPrice.displayImage" alt="product-image" />
          </span>
          <p class="userdetail">
            <span class="name">{{availCutPrice.itemName}}</span>
            <span class="price">₹​ {{availCutPrice.pricingDTO.sellingPrice}}</span>
            <span class="location" v-if="availCutPrice.pricingDTO.totalPaidAmount > 0">{{$t('getThisItem' , {value:availCutPrice.pricingDTO.totalPaidAmount})}}</span>
            <span class="location" v-else>{{$t('getThisFree' , {value:'FREE'})}}</span>
          </p>
          <span class="cut_amount">
            <i class="material-icons">arrow_forward_ios</i>
          </span>
        </router-link>
      </ul>
      <div v-if="noData == true && this.availableCutpriceList && this.availableCutpriceList == 0" class="no_record">
        <div class="page-status-panel">
          <div class="img-block">
            <img src="../../assets/images/icons/norecord.svg" alt />
          </div>
          <div class="details-block">
            <h2>No Records Found</h2>
            <p>There was no record found that will you enter here.</p>
          </div>
        </div>
      </div>
      <infinite-loading @infinite="cutPriceAvailProducts" spinner="circles">
        <template slot="no-results">और रिकॉर्ड उपलब्ध नहीं है</template>
      </infinite-loading>

      <div class="loader" v-if="loading">
        <img src="../../assets/images/loader.gif" alt="loader" />
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "CutThePriceProductListing",
  data() {
    return {
      availableCutpriceList: [],
      availableCutPriceIndex: 0,
      loading: false,
      noData: false
    };
  },
  methods: {
    cutPriceAvailProducts($state) {
      this.loading = true;
      this.$store
        .dispatch({
          type: "getProductType",
          payload: "CUT_PRICE?page=" + this.availableCutPriceIndex
        })
        .then(data => {
          this.loading = false;

          if (data.data.merchandiseCutPriceDTOs.length > 0) {
            this.availableCutpriceList.push(
              ...data.data.merchandiseCutPriceDTOs
            );
            this.$store.commit("saveAvailProductCutPrice", {
              availCutPriceListData: this.availableCutpriceList,
              availCutPriceIndex: this.availableCutPriceIndex + 1
            });
            this.availableCutPriceIndex += 1;
            $state && $state.loaded();
          } else {
            this.noData = true
            $state && $state.complete();
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.loading = true;
  }
};
</script>
    